exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info_add_invited{text-align:center;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%)}.info_add,.info_add_invited{width:100%;height:auto;font-size:12px;color:rgba(0,0,0,.54);margin-top:10px;margin-left:16px;margin-bottom:0}", ""]);

// exports
